var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
/* eslint-disable react/jsx-no-undef */
/* eslint-disable react/react-in-jsx-scope */
import React, { useEffect, useState } from "react";
import { graphql, compose, withGraphqlErrorFlags, withLoadingSpinner, withMountTracking, withShowFlag, withServiceNotFoundHandler, Separator, Card, Button, Spinner, Table, Link, ReactRouter } from "@atlassiansox/microscopekit";
import { lifecycle } from "recompose";
import serviceQuery from "../graphql/service.query.graphql";
import TemplateDetailsQuery from "../graphql/template-details.query.graphql";
import { TaskGroupView } from "../components/TaskGroupView";
import { indexOf } from "lodash";
import { TaskGroupFormFc } from "../components/FormView/TaskGroupFormFc";
import ServiceContainersQuery from "../graphql/service-containers.query.graphql";
import ServiceMicrosGroupsQuery from "../graphql/service-micros-group.query.graphql";
import { EditTemplateMutation, PremiseType, TaskExecutionMode, WargameTemplatePublishStatus } from "../graphql";
import styled from "styled-components";
import { isRequestDataValid } from "../models/Premise";
import { getPremiseToEdit, isPremiseValid } from "../hooks/createTemplatePage/usePremise";
import { PremiseEditor } from "../components/FormView/PremiseEditor";
import { PremiseDetailView } from "../components/PremiseDetailView";
import { parseDateTime } from "../utils";
import { ButtonGroup, LoadingButton } from "@atlaskit/button";
import { useMutationUI } from "../hooks";
import { getFaultParameters } from "../components/FormView/PublishTemplateForm";
import { useAnalytics, useSendScreenEvent } from "../analytics";
import { IsPremiseDisabled, PremiseDisabledSectionMessage } from "../utils/premiseDisabled";
var PremiseEditorComponent = function (_a) {
    var premise = _a.premise, isLoading = _a.isLoading, premiseBeingEdited = _a.premiseBeingEdited, setPremiseBeingEdited = _a.setPremiseBeingEdited, startEditing = _a.startEditing, stopEditing = _a.stopEditing, submit = _a.submit, deletePremise = _a.deletePremise, environment = _a.environment;
    if (isLoading) {
        return React.createElement(Spinner, null, "Loading Template Details");
    }
    if (premiseBeingEdited) {
        return (React.createElement(PremiseEditor, { premise: premiseBeingEdited, setPremise: setPremiseBeingEdited, onCancel: stopEditing, onSubmit: submit }));
    }
    if (premise) {
        return (React.createElement(PremiseDetailView, { premise: premise, editForm: startEditing, onDelete: deletePremise }));
    }
    else {
        return (React.createElement("div", null,
            IsPremiseDisabled(environment) && (React.createElement(PremiseDisabledSectionMessage, { environment: environment })),
            React.createElement(Card, null,
                React.createElement("text", null, "No Premise Setup")),
            React.createElement("br", null),
            React.createElement(Button, { appearance: "primary", onClick: startEditing, disabled: IsPremiseDisabled(environment) }, "Setup Premise")));
    }
};
var TemplateEditComponent = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var wargameTemplate = (_b = (_a = props.templateDetailsData) === null || _a === void 0 ? void 0 : _a.warGameTemplate) !== null && _b !== void 0 ? _b : {};
    var _k = __read(useState((_c = wargameTemplate === null || wargameTemplate === void 0 ? void 0 : wargameTemplate.taskGroup) !== null && _c !== void 0 ? _c : []), 2), taskGroups = _k[0], setTaskGroups = _k[1];
    var _l = __read(useState((_e = (_d = wargameTemplate === null || wargameTemplate === void 0 ? void 0 : wargameTemplate.premise) === null || _d === void 0 ? void 0 : _d[0]) !== null && _e !== void 0 ? _e : null), 2), premise = _l[0], setPremise = _l[1];
    var _m = __read(useState(false), 2), isEditMode = _m[0], setIsEditMode = _m[1];
    var _o = __read(useState(undefined), 2), taskGroupInEditMode = _o[0], setTaskGroupInEditMode = _o[1];
    var _p = __read(useState(undefined), 2), taskGroupInEditModeIndex = _p[0], setTaskGroupInEditModeIndex = _p[1];
    var _q = __read(useState(true), 2), isTemplateValid = _q[0], setIsTemplateValid = _q[1];
    var sendUIEvent = useAnalytics().sendUIEvent;
    useSendScreenEvent("editWargamePlanScreen");
    var addTaskGroup = function (taskGroup) {
        var _a;
        var i = taskGroupInEditModeIndex !== null && taskGroupInEditModeIndex !== void 0 ? taskGroupInEditModeIndex : taskGroups.length;
        var tmpTaskGroups = taskGroups.filter(function (taskGroup) { return taskGroup !== taskGroupInEditMode; });
        // remove taskgroup being edited
        setTaskGroups(tmpTaskGroups);
        // ensure delay is 0 incase it is the first task group
        taskGroup.delayBeforeExecution = (_a = taskGroup === null || taskGroup === void 0 ? void 0 : taskGroup.delayBeforeExecution) !== null && _a !== void 0 ? _a : 0;
        // add updated task group back to its original position
        setTaskGroups(__spread(taskGroups.slice(0, i), [
            taskGroup
        ], taskGroups.slice(i + 1)));
        setIsEditMode(false);
        setTaskGroupInEditMode(undefined);
        setTaskGroupInEditModeIndex(undefined);
    };
    var editTaskGroup = function (taskGroupToEdit) {
        // Set the task group to edit
        setTaskGroupInEditMode(taskGroupToEdit);
        setTaskGroupInEditModeIndex(indexOf(taskGroups, taskGroupToEdit));
        setIsEditMode(true);
    };
    var deleteTaskGroup = function (taskGroupToDelete) {
        var tmpTaskGroups = [];
        var deletedTaskGroupIndex = 0;
        // remove the deleted task group
        taskGroups.forEach(function (taskGroup, index) {
            if (taskGroupToDelete !== taskGroup) {
                tmpTaskGroups.push(taskGroup);
            }
            else {
                deletedTaskGroupIndex = index;
            }
        });
        // update delay before execution to 0 incase the first task group is deleted
        if (deletedTaskGroupIndex === 0 && tmpTaskGroups[0]) {
            tmpTaskGroups[0].delayBeforeExecution = 0;
        }
        setTaskGroups(tmpTaskGroups);
    };
    var cancelTaskGroupEdit = function () {
        if ((taskGroupInEditMode === null || taskGroupInEditMode === void 0 ? void 0 : taskGroupInEditMode.faults.length) === 0) {
            var tmpTaskGroups = taskGroups.filter(function (taskGroup) { return taskGroup !== taskGroupInEditMode; });
            setTaskGroups(tmpTaskGroups);
        }
        setIsEditMode(false);
        setTaskGroupInEditMode(undefined);
        setTaskGroupInEditModeIndex(undefined);
    };
    var createTaskGroup = function () {
        var newTaskGroup = {
            steadyStates: [],
            faults: [],
            delayBeforeExecution: 150
        };
        setTaskGroups(__spread(taskGroups.slice(0, taskGroups.length), [newTaskGroup]));
        setIsEditMode(true);
        setTaskGroupInEditMode(newTaskGroup);
        setTaskGroupInEditModeIndex(taskGroups.length);
    };
    var _r = __read(useState(null), 2), premiseBeingEdited = _r[0], setPremiseBeingEdited = _r[1];
    var startEditing = function () {
        setPremiseBeingEdited(getPremiseToEdit(premise));
    };
    var stopEditing = function () {
        setPremiseBeingEdited(null);
    };
    var submitPremise = function () {
        if (!premiseBeingEdited || !isPremiseValid(premiseBeingEdited)) {
            return;
        }
        var basePremise = {
            provider: premiseBeingEdited.provider,
            inputType: premiseBeingEdited.inputType,
            inputData: {
                user_count: premiseBeingEdited.inputData.user_count,
                steady_state_time: premiseBeingEdited.inputData.steady_state_time,
                ramp_up_time: premiseBeingEdited.inputData.ramp_up_time,
                custom_env_variables: premiseBeingEdited.inputData.custom_env_variables
            }
        };
        var inputData = basePremise.inputData;
        if (premiseBeingEdited.inputType === PremiseType.perfhammer_apis) {
            inputData.apis = premiseBeingEdited.inputData.apis;
            inputData.request_method = premiseBeingEdited.inputData.request_method;
            if (isRequestDataValid(premiseBeingEdited)) {
                inputData.request_data = premiseBeingEdited.inputData.request_data;
            }
        }
        else if (premiseBeingEdited.inputType === PremiseType.perfhammer_scripts) {
            inputData.repo = premiseBeingEdited.inputData.repo
                ? premiseBeingEdited.inputData.repo
                : "git@bitbucket.org:atlassian/resilience-lg.git";
            inputData.script_name = premiseBeingEdited.inputData.script_name;
            inputData.branch = premiseBeingEdited.inputData.branch;
        }
        else if (premiseBeingEdited.inputType === PremiseType.perfhammer_sqs) {
            inputData.queue_url = premiseBeingEdited.inputData.queue_url;
            inputData.request_data = premiseBeingEdited.inputData.request_data;
        }
        setPremise(basePremise);
        stopEditing();
    };
    var deletePremise = function () {
        setPremise(null);
    };
    var history = ReactRouter.useHistory();
    var _s = useMutationUI({
        mutation: EditTemplateMutation,
        successMessage: "Wargame Template Edited successfully",
        options: {
            variables: {
                wargameTemplate: {
                    name: wargameTemplate.name,
                    description: "",
                    environment: wargameTemplate.environment,
                    wargameParent: "",
                    version: wargameTemplate.version,
                    service: props.id,
                    premise: premise != null
                        ? [
                            {
                                name: "",
                                description: "",
                                provider: premise.provider,
                                inputType: premise.inputType,
                                inputData: {
                                    request_data: premise.inputData.request_data,
                                    apis: premise.inputData.apis,
                                    repo: premise.inputData.repo,
                                    branch: premise.inputData.branch,
                                    script_name: premise.inputData.script_name,
                                    user_count: premise.inputData.user_count,
                                    ramp_up_time: premise.inputData.ramp_up_time,
                                    steady_state_time: premise.inputData.steady_state_time,
                                    queue_url: premise.inputData.queue_url,
                                    request_method: premise.inputData.request_method,
                                    custom_env_variables: premise.inputData.custom_env_variables
                                }
                            }
                        ]
                        : null,
                    taskGroup: taskGroups !== undefined
                        ? taskGroups.map(function (taskGroup) { return ({
                            name: "",
                            executionMode: TaskExecutionMode.sequential,
                            delayBeforeExecution: taskGroup.delayBeforeExecution,
                            steadyStates: taskGroup.steadyStates.map(function (steadyState) { return ({
                                probeAction: steadyState.probeAction,
                                probeCategory: steadyState.probeCategory,
                                parameters: steadyState.parameters
                            }); }),
                            faults: taskGroup.faults.map(function (faultInput) { return ({
                                faultCategory: faultInput.faultCategory,
                                faultAction: faultInput.faultExecution,
                                delayBeforeExecution: faultInput.delayBeforeExecution,
                                faultParameters: getFaultParameters(faultInput.faultExecution, faultInput.parameters)
                            }); })
                        }); })
                        : [],
                    publishStatus: WargameTemplatePublishStatus.published
                }
            },
            onCompleted: function (data) {
                history.push("./template-details?id=" + data.editWargameTemplate.id);
            }
        }
    }), mutate = _s.mutate, isLoading = _s.isLoading;
    var handlePublish = function () {
        sendUIEvent({
            source: "editWargamePlanTemplate",
            actionSubject: "button",
            action: "clicked",
            actionSubjectId: "editWargameButton",
            attributes: {
                id: wargameTemplate.id
            }
        });
        mutate();
    };
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g;
        if (!props.templateDetailsData.loading &&
            props.templateDetailsData.warGameTemplate !== undefined) {
            props.serviceContainersData.refetch({
                service: props.id,
                env: wargameTemplate.environment,
                skip: false
            });
            props.serviceMicrosContainerData.refetch({
                service: props.id,
                environment: wargameTemplate.environment,
                skip: false
            });
            setTaskGroups((_c = (_b = (_a = props.templateDetailsData) === null || _a === void 0 ? void 0 : _a.warGameTemplate) === null || _b === void 0 ? void 0 : _b.taskGroup) !== null && _c !== void 0 ? _c : []);
            setPremise((_g = (_f = (_e = (_d = props.templateDetailsData) === null || _d === void 0 ? void 0 : _d.warGameTemplate) === null || _e === void 0 ? void 0 : _e.premise) === null || _f === void 0 ? void 0 : _f[0]) !== null && _g !== void 0 ? _g : null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.templateDetailsData]);
    useEffect(function () {
        setIsTemplateValid(taskGroups.length > 0 && !isEditMode && premiseBeingEdited === null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [[taskGroups, isEditMode]]);
    return props.templateDetailsData.loading ? (React.createElement(Spinner, null)) : (React.createElement("div", null,
        React.createElement(Container, null,
            React.createElement(Card, null,
                React.createElement(Table, { title: "Basic Information", cells: [
                        ["name", wargameTemplate.name ? wargameTemplate.name : ""],
                        [
                            "version",
                            wargameTemplate.version ? wargameTemplate.version : ""
                        ],
                        [
                            "environment",
                            wargameTemplate.environment ? wargameTemplate.environment : ""
                        ],
                        [
                            "Created At",
                            wargameTemplate.createdAt
                                ? parseDateTime(wargameTemplate.createdAt)
                                : ""
                        ],
                        [
                            "Last Updated At",
                            wargameTemplate.updatedAt
                                ? parseDateTime(wargameTemplate.updatedAt)
                                : ""
                        ]
                    ] })),
            React.createElement("h2", null, " Premise Setup"),
            React.createElement(Separator, null),
            React.createElement(PremiseEditorComponent, { premise: premise, premiseBeingEdited: premiseBeingEdited, setPremiseBeingEdited: setPremiseBeingEdited, isLoading: false, deletePremise: deletePremise, submit: submitPremise, startEditing: startEditing, stopEditing: stopEditing, environment: (_g = (_f = props.templateDetailsData) === null || _f === void 0 ? void 0 : _f.warGameTemplate) === null || _g === void 0 ? void 0 : _g.environment }),
            React.createElement("h2", null, "Task Group List"),
            React.createElement(Separator, null),
            taskGroups.map(function (taskGroup, index) {
                var _a, _b, _c;
                return (React.createElement("div", null,
                    React.createElement(Separator, null),
                    taskGroupInEditModeIndex !== index ? (React.createElement(TaskGroupView, { taskGroup: taskGroup, index: index, editFc: editTaskGroup, deleteFc: deleteTaskGroup, key: "TaskGroupView" + index, isCollapsedInitially: index !== 0 })) : (React.createElement(TaskGroupFormFc, { containersForService: props.serviceContainersData.containersForService, microsGroupsForService: props.serviceMicrosContainerData.microsGroupsForService, addTaskGroup: addTaskGroup, cancelTaskGroupEdit: cancelTaskGroupEdit, taskGroup: taskGroupInEditMode, taskGroupIndex: taskGroupInEditModeIndex, serviceId: props.id, environment: (_c = (_b = (_a = props.templateDetailsData) === null || _a === void 0 ? void 0 : _a.warGameTemplate) === null || _b === void 0 ? void 0 : _b.environment) !== null && _c !== void 0 ? _c : "" })),
                    React.createElement(Separator, null)));
            }),
            React.createElement("div", { hidden: taskGroups.length !== 0 },
                React.createElement(Card, null, "No task groups"),
                React.createElement(Separator, null)),
            React.createElement("div", { hidden: isEditMode },
                React.createElement(Button, { appearance: "primary", onClick: createTaskGroup }, "Add task group")),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement(Row, null,
                React.createElement(ButtonGroup, null,
                    React.createElement(Link, { to: "./template-details?id=" + ((_j = (_h = props.templateDetailsData) === null || _h === void 0 ? void 0 : _h.warGameTemplate) === null || _j === void 0 ? void 0 : _j.id) },
                        React.createElement(Button, null, "Cancel")),
                    React.createElement(LoadingButton, { appearance: "primary", isDisabled: !isTemplateValid, isLoading: isLoading, onClick: handlePublish }, "Publish"))),
            React.createElement("br", null))));
};
export var TemplateEditPage = compose(graphql(serviceQuery, {}), graphql(TemplateDetailsQuery, {
    name: "templateDetailsData",
    options: function (_a) {
        var templateId = _a.templateId;
        return ({
            query: TemplateDetailsQuery,
            variables: { id: templateId, skip: false }
        });
    }
}), graphql(ServiceContainersQuery, {
    name: "serviceContainersData",
    options: function (_a) {
        var id = _a.id, environment = _a.environment;
        return ({
            query: ServiceContainersQuery,
            variables: { service: id, env: environment, skip: true }
        });
    }
}), graphql(ServiceMicrosGroupsQuery, {
    name: "serviceMicrosContainerData",
    options: function (_a) {
        var id = _a.id, environment = _a.environment;
        return ({
            query: ServiceMicrosGroupsQuery,
            variables: { service: id, environment: environment, skip: true }
        });
    }
}), withLoadingSpinner, withShowFlag, withGraphqlErrorFlags, withServiceNotFoundHandler, withMountTracking("Credo.CredoPage"), lifecycle({
    componentDidMount: function () {
        var search = window.location.search;
        var templateId = new URLSearchParams(search).get("id");
        if (!this.props.templateDetailsData.warGameTemplate) {
            this.props.templateDetailsData.refetch({ id: templateId, skip: false });
        }
    }
}))(TemplateEditComponent);
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 1000px;\n  margin: 50px 250px;\n"], ["\n  max-width: 1000px;\n  margin: 50px 250px;\n"])));
var Row = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  margin-left: 850px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  margin-left: 850px;\n"])));
var templateObject_1, templateObject_2;
